import * as trans from "../common/Translator";
import {translateId, translateNaMaText} from "../common/Translator";
import * as ClientCache from "../login/ClientCache";
import {ajaxJSONWithoutWait, ajaxJSONWithTask, isEmptyOrNull, isNotEmptyOrNull, isNullOrUndefined} from "./NamaCommon";
import * as OwnerType from "../constants/OwnerType";
import * as DomainBaseEntities from "../constants/DomainBaseEntities";
import * as PreferencesRequest from "../constants/PreferencesRequest";
import * as metadata from "./Metadata";
import {createTroubleTicketActionHandler} from "../routing/EditPresenter";
import * as urls from "../constants/NamaURLS";
import * as NamaURLS from "../constants/NamaURLS";
import moment from 'moment'
import {isMobileDevice} from "./GUIUtilities";
import {showNotification} from "./TooltipUtil";
import {toCSVLineWithSep} from "./StringUtils";

export let errorsNotification = null;
let documentBookMetaData;
let lastServerLog;

export function findFieldAndHighLightIt(fieldId, row, owner, widgetPageIndex, element) {
    if (widgetPageIndex != -1 && widgetPageIndex != owner.currentPageIndex)
        owner.view.find("#tabstrip").data("kendoTabStrip").select(widgetPageIndex);
    if (!element || !element.length)
        return;
    let hasRow = (row != undefined && row != -1) || (element[0].nodeName && element[0].nodeName.toLowerCase() === 'th');
    setTimeout(() => {
        owner.view.find(".k-state-active[role='tabpanel']").scrollTop(0);
        owner.view.find(".k-state-active[role='tabpanel']").scrollTop(element.offset().top - (200 + owner.view.find(".page-top-header").height() + owner.view.parent().find("#nama-erp-header").height()));
        highlightField(element, hasRow ? "highlightedCell" : "highlightedField", 0, 3);
    }, 1000);
}

export function findHelpMsgAndShowIt(reqData, callBack) {
    ajaxJSONWithTask(NamaURLS.SearchForHelpMsgs, {request: JSON.stringify(reqData)}, (result) => {
        if (!result.helps && !result.systemHelps)
            return;
        if (callBack)
            callBack();
        let helpsContent = "";
        if (isNotEmptyOrNull(result.helps)) {
            helpsContent += toCSVLineWithSep("<br/><br/>", result.helps);
        }
        if (isNotEmptyOrNull(result.systemHelps)) {
            helpsContent += "<hr/>";
            helpsContent += toCSVLineWithSep("<br/><br/>", result.systemHelps);
        }
        showNotification(helpsContent);
    });
}

export class ErrorsNotification {
    constructor(owner, errors) {
        let that = this;
        that.owner = owner;
        that.listOfErrors = errors;
        that.msgNumber = 0;
        $(`<span id="notification" style="display:none;"></span>`).appendTo("body");
        let notification = $("#notification").kendoNotification({
            position: {
                pinned: true,
                top: 30,
                right: 30
            },
            stacking: "down",
            templates: [{
                type: "info",
                template: ` <div class="new-mail">
                    <h3>#= title #</h3>
                    <p>#= message #</p>
                </div>`
            }, {
                type: "warning",
                template: `<div id="warningContainer" style="text-align: center;">
                    <div class="row"><div class="col-md-10"><h3 id = "title">#= title #</h3></div>
                    </div>
                    <p><a id ="nextError" class='k-icon k-i-arrow-chevron-left pull-left'></a>
                    <span id = "warningMsg">#= message #</span>
                    <a id ="prevError" class='k-icon k-i-arrow-chevron-right pull-right'></a></p>
                </div>`
            }
                , {
                    type: "error",
                    template: `<div id="error-mess" class="wrong-pass" style="text-align: center;">
                    <div class="row"><div class="col-md-10"><h3 id = "title">#= title #</h3></div>
                     ${exportAndCreateTicketBtns(that)}
                    </div>
                    <p><a id ="nextError" class='k-icon k-i-arrow-chevron-left pull-left'></a>
                    <span id = "errMsg">#= message #</span>
                    <div class="row" style="display: #= relatedToDisplayType #"><div class="col-md-10"><span id = "errMsg"><a href="\\#edit:id/#= relatedOptionId #&view/EDIT&pgid/1&focusOnField/#= relatedOptionName #&entity/#= relatedOptionType #">#= urlTitle #</a></span></div>
                    <a id ="prevError" class='k-icon k-i-arrow-chevron-right pull-right'></a></p>
                </div>`
                }, {
                type: "success",
                template: ` <div class="upload-success">
                    <h3>#= message #</h3>
                </div>`
            }],
            hideOnClick: false,
            hide: function () {
                notification.destroy();
            },
            width: isMobileDevice() ? "90%" : "50%",
            autoHideAfter: 0

        }).data("kendoNotification");
        errorsNotification = that;
        errorsNotification.notification = notification;
        errorsNotification.attachNotificationClickEvents();
    }

    attachNotificationClickEvents() {
        let that = this;
        $(document.body).on("click", "#createTroubleTicket", function (e) {
            e.preventDefault();
            onCreateTroubleTicketClick();
        });
        $(document.body).on("click", "#showErrorMsgHelp", function (e) {
            e.preventDefault();
            that.showErrorMsgHelp();
        });
        $(document.body).on("click", "#showErrorOriginalMsg", function (e) {
            e.preventDefault();
            that.showErrorOriginalMsg();
        });
        $(document.body).on("click", "#exportToExcel", function (e) {
            e.preventDefault();
            onExportClick();
        });
        $(document.body).on("click", "#nextError", function (e) {
            e.preventDefault();
            if (that.msgNumber < that.listOfErrors.length - 1)
                that.msgNumber++;
            else
                that.msgNumber = 0;
            showErrors(that.listOfErrors, that.owner, that.msgNumber);
        });
        $(document.body).on("click", "#prevError", function (e) {
            e.preventDefault();
            if (that.msgNumber > 0)
                that.msgNumber--;
            else
                that.msgNumber = that.listOfErrors.length - 1;
            showErrors(that.listOfErrors, that.owner, that.msgNumber);
        });
        $(document.body).on("click", "#error-mess ", function (e) {
            e.preventDefault();
            if (e.target.id === 'errMsg' && that.msgNumber >= 0 && that.owner) {
                let currentError = that.listOfErrors[that.msgNumber];
                let widgetPageIndex = that.owner.getPageContainsWidget(currentError.ownerId);
                let element = that.owner.getFieldWithId(currentError.row, currentError.ownerId);
                findFieldAndHighLightIt(currentError.ownerId, currentError.row, that.owner, widgetPageIndex, element);
            }
        });
        $(document.body).on("click", function (e) {
            let elements = errorsNotification.notification.getNotifications();
            if (!elements)
                return;
            if (!e.target.closest("#error-mess") && errorsNotification.notification) {
                errorsNotification.notification.hide();
            }
        });
    }

    getFieldWithError(error) {
        let that = this;
        if (!that.owner || !error.ownerId)
            return null;
        return that.owner.getFieldWithId(error.row, error.ownerId);
    }


    linkErrorsToFields() {
        let that = this;
        let errors = that.listOfErrors;
        for (let error of errors) {
            let title = error.message.englishText;
            if (trans.isArabic())
                title = error.message.arabicText;
            let hasRow = error.row != undefined && error.row != -1;
            let fieldWithErrorClass = hasRow ? "invalidCell" : "invalidInput";
            let linkedElement = that.getFieldWithError(error);
            if (linkedElement) {
                linkedElement.addClass(fieldWithErrorClass);
                let kendoTooltip = linkedElement.data("kendoTooltip");
                if (kendoTooltip) {
                    let oldContent = kendoTooltip.options.content();
                    if (!oldContent.contains(title)) {
                        kendoTooltip.options.content = e => {
                            return `${oldContent}<br>${title}`;
                        };
                        kendoTooltip.refresh();
                    }
                }
                else {
                    linkedElement.kendoTooltip({
                        show: (e) => {
                            if (!linkedElement.hasClass(fieldWithErrorClass)) {
                                linkedElement.data("kendoTooltip").destroy();
                            }
                            else {
                                e.sender.popup.element.addClass("errorsTooltip");

                            }
                        },
                        content: (e) => {
                            return `${title}`;
                        },
                        autoHide: true
                    });
                }
            }
        }
    }

    showCurrentErrorNotification(isError) {
        let that = this;
        let messageNum = that.msgNumber;
        let message = '';
        let urlTitle = '';
        let relatedOptionName = '';
        let relatedOptionType = '';
        let relatedOptionId = '';
        let title = isError ? trans.translateId('error') : "";
        /***
         * type {namaTypes.NaMaError[]}
         */
        let errors = that.listOfErrors;
        let numOfErrors = errors.length;
        if (numOfErrors > 1) {
            let msgNumberToShow = messageNum + 1;
            title += " " + msgNumberToShow + " - " + numOfErrors;
        }
        let relatedToDisplayType = ClientCache.shouldShowFieldInfo() || ClientCache.shouldShowIds() || ClientCache.isServerLogActive() ? "" : "none";
        if (errors.length) {
            let currentError = errors[messageNum];
            if (currentError.alwaysShowRelatedTo)
                relatedToDisplayType = "";
            let parts = [];
            if (currentError.relatedToOption)
                parts.push(translateId(currentError.relatedToOption));
            if (currentError.relatedToOptionType)
                parts.push(translateId(currentError.relatedToOptionType));
            if (currentError.relatedToOptionCode)
                parts.push(translateId(currentError.relatedToOptionCode));
            urlTitle = parts.join(" - ");
            relatedOptionName = currentError.relatedToOption ? currentError.relatedToOption : '';
            relatedOptionType = currentError.relatedToOptionType ? currentError.relatedToOptionType : '';
            relatedOptionId = currentError.relatedToOptionTypeId ? currentError.relatedToOptionTypeId : '';
            if (currentError.message) {
                message = translateNaMaText(currentError.message);
                if (trans.isArabic()) {
                    notificationDiv(isError).addClass("k-rtl");
                }
            } else if (isNotEmptyOrNull(currentError)) {
                message = currentError + "\n";
            }
        }
        if (isEmptyOrNull(message))
            return;
        let errorMsg = notificationDiv(isError);
        let notificationType = isError ? "error" : "warning";
        let notificationMsgPart = isError ? errorMsg.find("#errMsg") : errorMsg.find("#warningMsg");
        if (!errorMsg.length) {
            errorsNotification.notification.show({
                title,
                urlTitle,
                relatedOptionName,
                relatedOptionType,
                relatedOptionId,
                message,
                relatedToDisplayType
            }, notificationType);
            if (errors.length == 1) {
                hideNextAndPrevArrows(notificationDiv(isError));
            }
        } else {
            errorMsg.find("#title").text(title);
            notificationMsgPart.text(message);
        }

    }

    showErrorMsgHelp() {
        let that = this;
        let currentError = that.listOfErrors[that.msgNumber];
        if (!currentError)
            return;
        /**
         *
         * @type {namaTypes.DTOHelpMessagesRequest}
         */
        let reqData = {
            errorMsg: currentError.rawMessage
        };
        findHelpMsgAndShowIt(reqData, () => errorsNotification.notification.hide());
    }

    showErrorOriginalMsg() {
        let that = this;
        let currentError = that.listOfErrors[that.msgNumber];
        if (!currentError)
            return;
        showNotification(currentError.rawMessage);
    }
}

function notificationDiv(isError) {
    let div = isError ? $("#error-mess") : $("#warningContainer");
    return div;
}

export function onCreateTroubleTicketClick() {
    if (errorsNotification.notification)
        errorsNotification.notification.hide();
    if (documentBookMetaData == null) {
        let req = {owner: {ownerType: OwnerType.Entity, ownerId: DomainBaseEntities.DocumentBook}};
        req.properties = [PreferencesRequest.META_DATA];
        metadata.fetchPreferences(req, (value) => {
            documentBookMetaData = value.metaData;
            onCreateTroubleTicketClick();
        });
    } else {
        createTroubleTicketActionHandler(documentBookMetaData, lastServerLog, errorsNotification.listOfErrors);
    }
}

export function onExportClick() {
    let data = [];
    data.push(["Error", "Field ID", "Field Name", "Line Number"]);
    let errors = errorsNotification.listOfErrors.map(e => {
        let row = e.row;
        if (row != null && row >= 0)
            row += 1;
        else
            row = null;
        return [translateNaMaText(e.message), e.ownerId,
            translateId(e.ownerId), row ? row : ""];
    });
    data.push(...errors);
    let date = moment(new Date()).format("YYYYMMDDHHmm");
    let req = {
        data: JSON.stringify(data),
        fileName: "Errors" + date + ".xlsx"
    };
    ajaxJSONWithoutWait(urls.ExportToExcel, req, (result) => {
            window.open(result.data, "_blank");
        }
    );
}

export function setLastServerLog(faultInfo) {
    if (faultInfo && isNotEmptyOrNull(faultInfo.log))
        lastServerLog = faultInfo.log;
}

function hideNextAndPrevArrows(notificationDiv) {
    notificationDiv.find("#prevError").css("display", "none");
    notificationDiv.find("#nextError").css("display", "none");
}

function highlightField(element, highlightClassName, currentCount, highLightCount) {
    element.addClass(highlightClassName);
    setTimeout(() => {
        element.removeClass(highlightClassName);
        setTimeout(() => {
            while (currentCount < highLightCount) {
                currentCount++;
                highlightField(element, highlightClassName, currentCount, highLightCount);
            }
        }, 500);
    }, 500);
}

export function showWarnings(errors) {
    initNotification(null, errors, null);
    setNotificationDefaultOptions();
    errorsNotification.showCurrentErrorNotification();
}

export function showErrors(errors, owner, messageNum) {
    if (typeof errors === "string")
        return showError(errors);
    if (isNullOrUndefined(messageNum)) {
        let criticalMsgs = ClientCache.fetchCriticalMsgs();
        if (criticalMsgs)
            errors.push(...criticalMsgs);
    }
    initNotification(owner, errors, messageNum);
    setNotificationDefaultOptions();
    errorsNotification.showCurrentErrorNotification(true);
}

function setNotificationDefaultOptions() {
    errorsNotification.notification.setOptions({
        position: {
            pinned: true,
            top: 30,
            right: 30
        },
    });
}

export function showSuccess(message) {
    initNotification();
    setNotificationDefaultOptions();
    errorsNotification.notification.show({
        message: message
    }, "success");
}

export function showInfo(title, message) {
    initNotification();
    errorsNotification.notification.setOptions({
        position: {
            pinned: true,
            top: 0,
            left: 0
        },
        stacking: "down"
    });
    errorsNotification.notification.show({
        title: title,
        message: message
    }, "info");
}

export function showError(message) {
    showErrors([message]);
    hideNextAndPrevArrows($("#error-mess"));
}

function initNotification(owner, errors, messageNum) {
    if (!messageNum && errors)
        messageNum = 0;
    if (errorsNotification) {
        errorsNotification.listOfErrors = errors;
        errorsNotification.msgNumber = messageNum;
        if (owner) {
            errorsNotification.owner = owner;
        }

    }
    else {
        errorsNotification = new ErrorsNotification(owner, errors);
    }
    if (owner)
        errorsNotification.linkErrorsToFields();
}

export function lastServerLog_() {
    return lastServerLog;
}

export function exportAndCreateTicketBtns(errorNotification) {
    return `<div class="col-md-2">
                    <a id="exportToExcel" title='${translateId("exportcsv")}' class="fa fa-file-excel-o" href="\\#"></a>
                    <a id="createTroubleTicket" title='${translateId("createTroubleTicket")}' class="fa fa-plus-square" href="\\#"></a>
                     <a id="showErrorMsgHelp" title='${translateId("showHelpMessage")}' class="fa fa-question-circle" href="\\#"></a>
                     <a id="showErrorOriginalMsg" title='${translateId("showOriginalMsg")}' class="fa fa-info-circle" href="\\#"></a>
                     </div>`;
}
